"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectMemberMultiSelectValueTag = void 0;
var _react = _interopRequireWildcard(require("react"));
var _alloyReactAvatar = _interopRequireDefault(require("@adsk/alloy-react-avatar"));
var _alloyReactTooltip = _interopRequireDefault(require("@adsk/alloy-react-tooltip"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _ProjectMemberIcon = require("../../IssuesTab/shared-components/ProjectMemberIcon");
var _DeletedIssuesSpaceContext = require("../../DeletedIssuesSpaceContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProjectMemberMultiSelectValueTag = _ref => {
  let {
    value,
    label,
    memberType,
    onRemove,
    invalid = false,
    isDisabled = false,
    disabledTooltipContent
  } = _ref;
  const isDeletedIssuesSpaceActive = (0, _react.useContext)(_DeletedIssuesSpaceContext.DeletedIssuesSpaceContext);
  return /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.default, {
    content: isDisabled ? disabledTooltipContent : undefined
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      margin: "3px 6px 3px 0",
      paddingLeft: 6,
      paddingRight: 6,
      borderRadius: 3,
      backgroundColor: invalid ? _alloyReactTheme.default.colors.red300 : _alloyReactTheme.default.colors.charcoal100,
      color: isDisabled ? _alloyReactTheme.default.colors.charcoal500 : _alloyReactTheme.default.colors.charcoal900,
      minHeight: 29
    }
  }, /*#__PURE__*/_react.default.createElement(_alloyReactAvatar.default, {
    size: _alloyReactAvatar.default.SIZES.SMALL_16,
    style: {
      backgroundColor: _alloyReactTheme.default.colors.charcoal200
    }
  }, /*#__PURE__*/_react.default.createElement(_ProjectMemberIcon.ProjectMemberIcon, {
    color: _alloyReactTheme.default.colors.charcoal500,
    memberType: memberType,
    size: 14
  })), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginLeft: 8,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      ..._alloyReactTheme.default.typography.bodyMedium
    }
  }, label), !isDeletedIssuesSpaceActive && /*#__PURE__*/_react.default.createElement(_alloyReactIcon.XIcon, {
    style: {
      marginLeft: 8
    },
    size: 16,
    onClick: () => !isDisabled && onRemove(value)
  })));
};
exports.ProjectMemberMultiSelectValueTag = ProjectMemberMultiSelectValueTag;
//# sourceMappingURL=ProjectMemberMultiSelectValueTag.js.map